<template>
    <div>
        <navigation/>

        <blog-list/>

    </div>
</template>

<script>
    import Navigation from '../layout/MainNavigation.vue';
    import BlogList from './BlogList.vue';

    export default {
        name: 'BlogsList',
        metaInfo: {
            title: 'Explore our Blogs'
        },
        data() {
            return {}
        },
        mounted() {

        },
        methods: {

        },
        components: {
            Navigation,
            BlogList
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/blogs/BlogsPage.vue